export default "__VITE_ASSET__DahTdKLD__"